import React from 'react'
import PropTypes from 'prop-types'

import styled, { css } from 'styled-components'
import { width_height_24 } from 'components/corpSite/components/theme/width-height'
import { xsMd, mdLg } from 'components/corpSite/components/theme/utils/media-query'
import { h1_bold, body_large_bold, d2_bold } from 'components/corpSite/components/theme/type-styles'
import { spacing_0_75, spacing_1 } from 'components/corpSite/components/theme/spacing'
import { primaryForSite } from 'components/corpSite/components/theme/colors'

const HomePhoneImg = styled.img`
  width: 291px;
  align-self: flex-end;
  ${() =>
    xsMd(
      css`
         {
          display: none;
        }
      `
    )};
`

const StyledHero = styled.div`
  width: 100vw;
  ${width_height_24(false, true)};

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 80px;

  text-align: left;

  background: rgb(4, 133, 126);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: absolute;

  section {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    flex-direction: column;
    width: 512px;
  }

  ${(props) =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}

  h1 {
    ${d2_bold};
    color: ${(props) => props.textColor};
    margin-bottom: 0;
  }

  h3 {
    ${body_large_bold};
    color: ${(props) => props.textColor};
    margin-top: ${spacing_0_75};
    margin-bottom: 0;
  }

  ${xsMd(css`
    top: 48px;
    section {
      margin: ${spacing_1};
    }

    h1 {
      ${h1_bold};
      color: ${(props) => props.textColor};
    }
  `)}
  ${mdLg(css`
    section {
      width: 440px;
    }
  `)}
`

export default function ColoredHero(props) {
  return (
    <StyledHero {...props}>
      <section>
        <h1>{props.header}</h1>
        <h3>{props.subheader}</h3>
      </section>
      <HomePhoneImg src={props.image} />
    </StyledHero>
  )
}

ColoredHero.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
}
